import { compatWrapper } from '@backstage/core-compat-api';
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const componentFilter = (entity: { kind: string }) =>
  entity.kind.toLocaleLowerCase('en-US') === 'component';

export const securityPage = PageBlueprint.make({
  name: 'security',
  params: {
    path: '/security',
    title: 'Security',
    loader: async () =>
      import('./SecurityPage').then(module => <module.SecurityPage />),
  },
});

export const anderSecurityReportsContent = EntityContentBlueprint.make({
  name: 'security',
  params: {
    path: 'security',
    title: 'Security',
    filter: componentFilter,
    loader: async () =>
      import('./AnderSecurityReportsContent').then(module =>
        compatWrapper(<module.AnderSecurityReportsContent />),
      ),
  },
});

export const anderSecurityReportsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [securityPage, anderSecurityReportsContent],
});
